<!--
 * @FilePath: /daren-html-source/src/components/NavLeft/index.vue
 * @Description: 左侧菜单栏
-->
<template>
  <div class="NavLeft">
    <!-- <div class="navTitle">飞猫达人中心</div> -->
    <div>
      <div
        class="item"
        v-for="item in navList"
        :key="item.id"
        :class="item.pathArr.indexOf($route.name) >= 0 ? 'act' : ''"
        @click="itemClick(item)"
      >
        <svg-btn :icon-class="'icon-menu-' + item.id" />
        <div :style="{display: $i18n.locale == 'en' ? '' : 'flex'}" style="align-items: center;">{{ item.pathName }}
        <div :style="{marginLeft: $i18n.locale == 'en' ? '0px' : '4px'}" class="Betas" v-if="item.id == 22">Beta</div></div>
      </div>
    </div>
    <div class="bottomBox">
      <span class="arrow">Copyright © 2025 CloudMaster(HongKong) Limited</span>
    </div>
    <Step1
      :isShow="showStep1"
      @confirm="open()"
      @handleClose="closeStep2()"
    ></Step1>
    <ChangePhoneDiaVue
      ref="ChangePhoneDia"
      @confirm="bindPhoneConfirm()"
      :userInfo="$store.state.userInfo"
      :showChangePhoneFlag="showChangePhoneFlag"
      @handleClose="showChangePhoneFlag = false"
    ></ChangePhoneDiaVue>
    <AddPayee :isShow="showAddpayFlag" @confirm="openDaren" />
  </div>
</template>

<script>
import { openDarenAPINew, userInfoAPI } from '@/utils/apiList/user'
import Step1 from '@/components/OpenDarenDia/step1.vue'
import AddPayee from '@/components/AddPayee/index.vue'
import ChangePhoneDiaVue from '@/components/ChangePhoneDIa/index.vue'
export default {
  data() {
    return {
      //1、左侧取消订阅号入口、
      //2、将收益提现变成一级菜单放在左侧导航栏倒数第二位。
      //3、新的 收益提现 账号管理两个都是一级菜单只有唯一页面，所以取消二级按钮如图所示。
      routeAct: 0,
      showStep1: false,
      showChangePhoneFlag: false,
      showAddpayFlag: false,
      itemId:'',
    }
  },
  components: {
    Step1,
    ChangePhoneDiaVue,
    AddPayee,
  },
  computed: {
    navList() {
      const userInfo = this.$store.state.userInfo || {};
      const referralProgramEnabled = userInfo.referral_program_switch == 1;
      const shortswitch = userInfo?.switchs?.short_url_switch == 1;
      return [
        {
          id: 0,
          pathName: this.$t('NavLeft.FEEMOO'),
          path: '/drive',
          pathArr: ['drive', 'homepage'],
        },
        // 根据shortswitch值动态添加短链菜单项
        ...(shortswitch
          ? [
              {
                id: 22,
                pathName: this.$t("NavLeft.Fm2shortlink"),
                path: "/shortlink",
                pathArr: ["shortlink"],
              },
            ]
          : []),
        {
          id: 2,
          pathName: this.$t('NavLeft.PromotionCode'),
          path: '/memberRebate',
          pathArr: ['memberRebate'],
        },
        // 动态菜单项
        ...(referralProgramEnabled ? [
          {
            id: 7,
            pathName: this.$t('exPand.referralProgram'),
            path: '/referralProgram',
            pathArr: ['referralProgram'],
          }
        ] : [
          {
            id: 3,
            pathName: this.$t('NavLeft.DownlineRebate'),
            path: '/offlineRebate',
            pathArr: ['offlineRebate'],
          }
        ]),
        {
          id: 4,
          pathName: this.$t('NavLeft.HelpCenter'),
          path: '/help',
          pathArr: ['help'],
        },
        {
          id: 6,
          pathName: this.$t('NavLeft.BalanceWithdrawal'),
          path: '/income',
          pathArr: ['income'],
        },
        {
          id: 5,
          pathName: this.$t('NavLeft.AccountManagement'),
          path: '/account',
          pathArr: ['account'],
        },
      ];
    }
  },
  methods: {
    itemClick(item) {
      this.itemId = item.id
      if (!this.$utils.getCookie(this.$glb.fmCookieName)) {
        const from = 'daren'
        const fromUrl = this.$glb.darenUrl + item.path
        const encodedFrom = encodeURIComponent(from)
        const encodedFromUrl = encodeURIComponent(fromUrl)
        let url =
          this.$glb.fmpUrl +
          `/login?from=${encodedFrom}&fromUrl=${encodedFromUrl}`
        this.$store.commit('setShowLoginInvite', url)
        this.$store.commit('setShowLogin', true)
        return
      }
      //引荐计划只需要绑定手机号，无需开通达人
      if(item.id == 7 || item.id == 4){
        if (this.$store.state.userInfo.is_bind_phone == 0) {
          this.$refs.ChangePhoneDia.step = 2
          this.$refs.ChangePhoneDia.topTit = '绑定手机号'
          this.showChangePhoneFlag = true
          return
        }
        this.$router.push(item.path)
        return
      }
      if (item.id !== 5 && localStorage.getItem('isDaren') == 0) {
        // this.$toast("开通成为飞猫达人即可查看", 2);
        // this.showStep1 = true
        this.open()
      }
      this.$router.push(item.path)
    },
    bindPhoneConfirm() {
      //引荐计划无需开通达人,无需设置收款人
      if (this.$store.state.userInfo.is_income_account == 0 && this.itemId != 7) {
        this.showChangePhoneFlag = false
        this.showAddpayFlag = true
      } else if (this.$store.state.userInfo.is_rate_flow != 1 && this.itemId != 7) {
          this.openDaren()
      }
    },
    open() {
      this.showStep1 = false
      if (this.$store.state.userInfo.is_bind_phone == 0) {
        this.$refs.ChangePhoneDia.step = 2
        this.$refs.ChangePhoneDia.topTit = '绑定手机号'
        this.showChangePhoneFlag = true
        return
      }
      if (this.$store.state.userInfo.is_income_account == 0) {
        this.showAddpayFlag = true
        return
      }
      this.openDaren()
    },
    openDaren() {
      openDarenAPINew()
        .then(res => {
          if (res.status == 1) {
            this.$toast(res.msg, 1)
            localStorage.setItem('isDaren', 1)
            this.getUser()
          } else {
            this.$toast(res.msg, 2)
          }
        })
        .catch(err => {})
    },
    getUser() {
      userInfoAPI()
        .then(res => {
          if (res.status == 1) {
            this.$store.commit('setAttr', {
              name: 'userInfo',
              val: res.data,
            })
            localStorage.setItem('isDaren', res.data.is_rate_flow)
            //引荐计划无需开通达人,无需设置收款人
            if(this.itemId == 7){
              this.$router.push('/referralProgram')
            }else{
              this.$router.push('/drive')
            }
          }
        })
        .catch(err => {})
    },
    closeStep2() {
      this.showStep1 = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
